module.exports = __webpack_public_path__ + "media/images/coris-money-50d507f3aea55df3c7183ac3d9270791.png";